module.exports = __webpack_public_path__ + "img/img-shipin-s7.b2b41235.png";